module.exports = __webpack_public_path__ + "static/img/sta-num.4d4db0ff.png";